<template>
    <div class="sa-tabble-layout">
        <div class="sa-tabble-layout-toolbar">
            <span class="sa-flexbox-body-title">Movimenti Contabili</span>
            <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" class="mb-2" @click="onClickAggiungiMovimentoContabile">
                <font-awesome-icon icon="plus"> </font-awesome-icon>
                Aggiungi
            </b-button>
            <b-button size="sm" variant="outline-purple outline-primary-noborder  sa-margin-right float-sm-right" @click="onClickStampa()">
                <b-icon icon="printer" />
                Stampa
            </b-button>
        </div>
        <div class="sa-tabble-layout-body">
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table" foot-clone>
                <template>
                    <span>{{ items.descrizioneMovimento }}</span>
                </template>
                <template #cell(dataOra)="{ item }">
                    {{ formatDateTime(item.dataOra) }}
                </template>
                <template #cell(tipoMovimento)="data">
                    <span v-if="data.item.tipoMovimento === 1">Versamenti</span>
                    <span v-else>Pagamenti</span>
                </template>
                <template #cell(importo)="item">
                    <span v-if="item.item.tipoMovimento > 0" class="positivo">{{ item.item.tipoMovimento * item.item.importo }} € </span>
                    <span v-else class="negativo">{{ item.item.tipoMovimento * item.item.importo }} €</span>
                </template>
                <template>
                    <span>{{ items.note }}</span>
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Movimento" @click="onClickModificaMovimentoContabile(item)">
                        <font-awesome-icon icon="edit"> </font-awesome-icon>
                    </b-button>
                    <b-button size="sm" v-b-tooltip.hover title="Cancella Movimento" variant="outline-danger" @click="onClickDeleteMovimentoContabile(item)">
                        <font-awesome-icon icon="trash"></font-awesome-icon>
                    </b-button>
                </template>
                <template v-slot:foot(descrizioneMovimento)>
                    <span></span>
                </template>
                <template v-slot:foot(dataOra)>
                    <span></span>
                </template>
                <template v-slot:foot(tipoMovimento)>
                    <span></span>
                </template>
                <template v-slot:foot(importo)>
                    <span>Totale: {{ calcolaTotale() }} €</span>
                </template>
                <template v-slot:foot(note)>
                    <span></span>
                </template>
            </b-table>
        </div>
        <div class="sa-tabble-layout-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-movimenti-contabili-modal-edit ref="RsaMovimentiContabiliModalEdit" :idAccettazione="idAccettazione" @aggiornamentoSalvato="loadData(idAccettazione)" />
        <print-component v-show="false" ref="cmpPrint"></print-component>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaMovimentiContabiliModalEdit from "./RsaMovimentiContabiliModalEdit.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        RsaMovimentiContabiliModalEdit,
        PrintComponent,
    },
    data() {
        return {
            isStampa: false,
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            pathResource: "/rsamovimenticontabili",
            linkedit: "/",
            // linkPrintData: "",
            filtro: {},
            jsonData: {
                id: null,
                idAccettazione: "",
            },
            showModalLoading: false,
            idAccettazione: "",
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 2rem",
                },

                {
                    label: "Descrizione",
                    key: "descrizioneMovimento",
                    thStyle: "width: 25rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOra",
                    thStyle: "width: 25rem",
                },
                {
                    label: "Tipo",
                    key: "tipoMovimento",
                    thStyle: "width: 10rem",
                },
                {
                    label: "Importo €",
                    key: "importo",
                    thStyle: "width: 10rem",
                },
                {
                    label: "Note",
                    key: "note",
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },

    methods: {
        calcolaTotale() {
            let totale = 0;
            if (this.items.length !== 0) {
                totale = this.items.reduce((sum, item) => sum + item.tipoMovimento * item.importo, 0);
            }

            return totale;
        },
        loadData(id) {
            let me = this;
            if (id) {
                me.idAccettazione = id;
            }
            if (sessionStorage["filtroMovimentiContabili"]) {
                me.filtro = JSON.parse(sessionStorage["filtroMovimentiContabili"]);
            }
            me.filtro.idAccettazione = id;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },

        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },

        loadDataError(response) {
            console.log(response);
        },

        onClickAggiungiMovimentoContabile() {
            let me = this;
            me.jsonData.idAccettazione = me.filtro.idAccettazione;
            let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + me.jsonData.idAccettazione;

            axios
                .get(url)
                .then((response) => {
                    let accettazione = response.data.data;
                    if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE") {
                        let messaggio = accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                        me.$bvModal.msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        });
                        return;
                    }
                    me.$refs.RsaMovimentiContabiliModalEdit.show(me.jsonData);
                })
                .catch((error) => {
                    console.error("Errore nel recupero dati accettazione:", error);
                    me.$bvToast.toast("Errore nel recupero dei dati del paziente.", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },

        onClickModificaMovimentoContabile(item) {
            let me = this;
            me.$refs.RsaMovimentiContabiliModalEdit.show(item);
        },

        onClickDeleteMovimentoContabile(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Parametri Vitali",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteMovimentoContabile(item);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteMovimentoContabile(item) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + item.id;
            UtilityMixin.methods.restCallDelete(link, me.resultDeleteResponse, me.resultDeleteError);
        },

        resultDeleteResponse(response) {
            let me = this;
            me.$emit("onDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.loadData(response.data.data.idAccettazione);
        },

        resultDeleteError(error) {
            let me = this;
            console.log(error);
            me.showModalLoading = false;
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        /*  stampaMovimentiContabili() {
            let me = this;
            me.isStampa = true;
            me.$nextTick(() => {
                const contenuto = document.getElementById("sezioneStampaMovimenti").innerHTML;
                const finestraStampa = window.open("", "", "height=700,width=900");
                finestraStampa.document.write(`
                  <html>
                    <head>
                      <title>Movimenti Contabili</title>
                      <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                        .positivo { color: #4caf50; }
                        .negativo { color: #f44336; }
                      </style>
                    </head>
                    <body>
                      <h2>Movimenti Contabili</h2>
                      ${contenuto}
                    </body>
                  </html>
                `);
                finestraStampa.document.close();
                finestraStampa.focus();
                finestraStampa.print();
                finestraStampa.close();
                me.isStampa = false;
            }); */
        //  },
        onClickStampa() {
            let me = this;
            if (sessionStorage["filtroMovimentiContabili"]) {
                me.filtro = JSON.parse(sessionStorage["filtroMovimentiContabili"]);
            }
            me.loadDataResources(me.pathResource + "/printdata/" + me.idAccettazione, me.filtro, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampa(error) {
            console.log(error);
        },
    },
};
</script>
<style>
.positivo {
    color: #4caf50;
}
.negativo {
    color: #f44336;
}
</style>
